import Chatbot from '@/api/chatbot/chatbot'
// import fileDownload from "js-file-download";

const chatbot = new Chatbot()

const chatbotModule = {
  namespaced: true,
  state: {
    items: [],
    lookups: [],
    item: null,
    total: 0,
    students: [],
    load: false,
  },
  getters: {
    items(state) {
      return state.items
    },
    load(state) {
      return state.load
    },
    item(state) {
      return state.item
    },
    total(state) {
      return state.total
    },
    students(state) {
      return state.students
    },
    lookups(state) {
      return state.lookups
    },
  },

  mutations: {
    SET_LOAD: (state, load) => {
      state.load = load
    },
    SET_ITEMS: (state, chatbot) => {
      state.items = chatbot
    },
    SET_TOTAL_CHATBOT: (state, total) => {
      state.total = total
    },
    SET_STUDENTS: (state, students) => {
      state.students = students
    },
    SET_ITEM: (state, school) => {
      state.item = school
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups
    },
  },

  actions: {
    list({ commit }, query) {
      return new Promise((resolve, reject) => {
        chatbot.list(query).then(response => {
          commit('SET_ITEMS', response)
          // commit("SET_TOTAL_CHATBOT", response.chatbot.total);
          resolve(response)
        })
      })
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        chatbot
          .put(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    store({ commit }, payload) {
      return new Promise((resolve, reject) => {
        chatbot
          .store(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        chatbot
          .update(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    get({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        commit('SET_ITEM', null)
        chatbot
          .get(id)
          .then(response => {
            commit('SET_ITEM', response.data)
            commit('SET_LOAD', false)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        chatbot
          .remove(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    chatbotLookups({ commit }) {
      return new Promise((resolve, reject) => {
        chatbot
          .lookups()
          .then(response => {
            commit('SET_LOOKUPS', response)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
  },
}

export default chatbotModule
